var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connectedgroups"},[_c('h5',{staticClass:"connectedgroups-title"},[_vm._v(_vm._s(_vm.item.content))]),_vm._l((_vm.groups),function(group,index){return _c('app-content-group',{key:index,attrs:{"item":group}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }